import { Route, Router, Switch } from 'react-router-dom';
import {
  AuthProvider,
  BrandProvider,
  ProgressProvider,
  RegistrationProvider,
  RoutesProvider,
  ToastProvider,
} from '../context';
import { history } from '../history';
import { HTMLHead } from '../HTMLHead';
import { ErrorPage } from '../pages/error/ErrorPage';
import { LoginPage } from '../pages/login/LoginPage';
import { LogoutPage } from '../pages/logout/LogoutPage';
import { MagicLinkRequestPage } from '../pages/magiclink/MagicLinkRequestPage';
import { MagicLinkSentPage } from '../pages/magiclink/MagicLinkSentPage';
import { SetupPage } from '../pages/setup/SetupPage';
import { SsoPage } from '../pages/sso/SsoPage';
import { AppFlowPicker } from './AppFlowPicker';
import { PrivateRoute } from './PrivateRoute';
import { FeatureProvider } from '../context/feature-provider/FeatureProvider';

/**
 * This is the root of this react app.
 * There are several special routes handled here.
 * All further routing is handled by 'AppFlowPicker'.
 *
 * Routing:
 * Routing is hierarchical, it can occur anywhere via a '<Switch ...>' component
 * and can be nested. The hash portion of the URL (the part after '#/') is used
 * in this app for routing. The first route that matches the URL hash is rendered.
 *
 * Navigation:
 * You can programmatically change the URL and navigate to another route by calling
 * 'src/history.ts' 'push(...)'. This can be hard to debug because some components
 * may redirect to other routes based on certain conditions. You can open the history
 * node module code in dev tools and add a breakpoint to the 'setState() function
 * inside 'createHashHistory()' (we use createHashHistory() in 'src/history.ts').
 
 * TODO:
 * Upgrading to react-router-dom@6.0.0 will require migrating off deprecated functionality like
 * the Switch and Route components
*/
export const Routes = () => (
  <AuthProvider>
    <FeatureProvider>
      <RegistrationProvider>
        <BrandProvider>
          <ProgressProvider>
            <ToastProvider>
              <HTMLHead />
              <Router history={history}>
                <Switch>
                  <Route path="/error/:status" component={ErrorPage} />
                  <Route exact path="/logout" component={LogoutPage} />
                  <Route exact path="/login" component={LoginPage} />
                  <Route exact path="/setup" component={SetupPage} />
                  <Route
                    exact
                    path={['/sso', '/sso/magiclink/:token?']}
                    component={SsoPage}
                  />
                  <Route
                    exact
                    path="/magiclink/sent"
                    component={MagicLinkSentPage}
                  />
                  <Route
                    exact
                    path="/magiclink/send/:previousToken?"
                    component={MagicLinkRequestPage}
                  />
                  <RoutesProvider>
                    <PrivateRoute path="/" component={AppFlowPicker} />
                  </RoutesProvider>
                </Switch>
              </Router>
            </ToastProvider>
          </ProgressProvider>
        </BrandProvider>
      </RegistrationProvider>
    </FeatureProvider>
  </AuthProvider>
);
